import React from 'react';
import { Modal, Button, Form, Divider } from 'antd';
import useExport from '../hooks/useExport';

const ModalExport = ({ visible, hideModal, headerData }) => {
    const [form] = Form.useForm(); // Initialize form instance
    const {
        loading,
        handleSubmit,
    } = useExport(hideModal, headerData);


    return (
        <Modal
            maskClosable={false}
            title={"Export"}
            open={visible}
            onCancel={hideModal}
            width={300}
            footer={null}
        >
            <Form
                form={form}
                name="basic"
                autoComplete="off"
                layout="vertical"
                onFinish={handleSubmit}
                loading={loading}
            >
                Apakah anda yakin ingin melakukan export data ini?
                <Divider />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                    <Button onClick={hideModal} disabled={loading}>Batal</Button>
                    <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>Lanjutkan</Button>
                </div>
            </Form>
        </Modal>
    );
};

export default ModalExport;
